import * as React from 'react';

/**
 * React state hook that returns the latest state as described in the React hooks FAQ.
 * This is mostly useful to get access to the latest value of some props or state inside an asynchronous callback,
 * instead of that value at the time the callback was created from.
 * */
const useLatest = <T extends any>(current: T) => {
    const storedValue = React.useRef(current);
    React.useEffect(() => {
        storedValue.current = current;
    });
    return storedValue;
};

export default useLatest;
